import { render, staticRenderFns } from "./ActiveSubscribers.vue?vue&type=template&id=9f84d7ba&scoped=true&"
import script from "./ActiveSubscribers.vue?vue&type=script&lang=js&"
export * from "./ActiveSubscribers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f84d7ba",
  null
  
)

export default component.exports